export const CONTACT_PHONE = {
    value: '+79361005040',
    formated_value: '+7 (936) 100-50-40'
};

export const CONTACT_EMAIL = 'info@polza.tech';

export const ARTICLES_LINK = 'https://articles.polza.tech'
export const INFO_LINK = 'https://info.polza.tech'